export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../../assets/images/services/banner-21.jpg'),
        title: '游戏领域',
        description: '',
        component: ''
      }
  ],
  items:[
    {
      title: '游戏领域',
      description: `<p >作为占据全球外包市场近半数份额的核心业务，我们组建了由2D/3D艺术家、动画师、UI/UX设计师构成的专业团队，精通Unity、Unreal等主流引擎适配标准，可承接全风格、全品类美术资产制作，累计交付200+成功项目，服务产品全球下载量超1亿次。</p>
<p>在全球游戏产业规模突破1800亿美元、玩家对品质需求持续升级的当下，游戏外包已从“成本优化工具”升级为“战略协同伙伴”。我们深耕游戏外包领域多年，以“技术驱动、品质为核、灵活适配”为理念，为全球游戏厂商提供从美术设计、程序开发到测试运维的一站式外包解决方案，助力客户聚焦核心创意，加速产品落地，抢占市场先机。无论是独立工作室的轻量化需求，还是3A大厂的规模化项目，我们都能以定制化服务破解研发瓶颈，实现效能与品质的双重提升。</p>`
    },
    {
      title: '我们的优势',
      description: `<span class='img' style="background:url(`+require('../../../assets/images/services/pic-21.jpg')+`)"></span>
      <span class="list">
      <i></i>顶尖研发团队，核心技术领先。<br/>
      <i></i>全球化发行网络，覆盖主流市场。<br/>
      <i></i>丰富 IP 储备，多元游戏品类。<br/>
      <i></i>持续创新能力，紧跟行业前沿。<br/>
      <i></i>无需额外的成本。<br/>
      </span>`
    }
  ]
}
